import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import TrafficlightButtonGreen from "../../../../../../../components/Button/TrafficlightButtonGreen";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextLeptinSignal } from "./TextLeptinSignal";


export default function Dia_Leptin_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
        <IconButton onClick={handleOpen}>
            <TrafficlightButtonGreen />
        </IconButton>

        <CustomDialog open={open} onClose={handleClose}

            title='Leptin Signaling Pathway - Analysis'

            content={ <TextLeptinSignal />}

            />
</>
)}